<template>
  <div class="Mental_health_report">
     <el-dialog title="提示" :visible.sync="loading" width="30%">
        <div class="dis-s" style="text-align: center;">
        <img style="width: 200px;height: 200px;" src="../../assets/4092865.gif" alt="">
        <p style="font-size: 18px;">数据加载中，请稍等...</p>
      </div>
    </el-dialog>

    <div class="nav">
        <p style="font-size: 18px;font-weight: 700;text-align:center;color: rgba(0, 70, 145, 1);margin-top:50px">{{ data.dates }}</p>
        <h2>中国科学院大学学生心理健康报告</h2>
        <p style="color: #fff;background: linear-gradient(270deg, rgba(62, 60, 209, 1) 0%, rgba(53, 143, 254, 1) 100%);height: 30px;width: 360px;text-align:center;line-height:30px;border-radius:20px;margin:auto;margin-top:30px">中国科学院大学心理健康教育中心（{{data.dates}}）</p>
        <p style="border-top: 1px dashed rgba(138, 164, 184, 1);margin-top:40px;"></p>

        <div class="cvs">
            <p>一、总体概况</p>
        </div>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">本次心理普查的主要内容是学生的心理问题症状与生活满意度，分别采用症状自评量表（SCL-90）和青少年学生生活满意度量表进行测试评估。截至{{ data.dates }}，贵单位应参测学生{{data.studentCount }}人，未测试学生中已休学的人数为{{data.studentCountUntestLeave}}人，实际参测学生{{ data.studentCountSj }}人，其中完成症状自评量表（SCL-90）{{ data.studentCountSCL90}}人次、完成青少年学生生活满意度量表{{data.studentCountLSOFT}}人次，实际完整参测学生{{ data.studentCountSjCount }}人，完成比{{ data.studentCountSjCountZb }}%。</p>


        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">本次心理普查，参加测试的男生有{{ data.sex1Count }}人，占参测人数的{{ data.sex1CountZb }}%;参测女生有{{ data.sex2Count }}人，占参测人数的{{
        data.sex2CountZb }}%</p>

        <table>
            <thead>
                <tr>
                    <th>性别</th>
                    <th>人数（人）</th>
                    <th>百分比（%）</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>男</td>
                    <td>{{ data.sex1Count }}</td>
                    <td>{{ data.sex1CountZb }}</td>
                </tr>
                <tr>
                    <td>女</td>
                    <td>{{ data.sex2Count }}</td>
                    <td>{{ data.sex2CountZb }}</td>
                </tr>

            </tbody>
        </table>

        <!-- <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;"></p>         -->
        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">本次心理普查，国科大学籍学生中，参测本科生{{ data.bkxj }}人，占参测人数的{{ data.studentCountSj == 0 ? 0: ((Number(data.bkxj)  / Number(data.studentCountSj)) * 100).toFixed(2) }}%，硕士研究生有{{
        data.ssxj }}人，占参测人数的{{ data.studentCountSj==0? 0 : ((Number(data.ssxj) / Number(data.studentCountSj)) * 100).toFixed(2) }}%，参测博士研究生有{{ data.bsxj }}人，占参测人数的{{ data.studentCountSj ==0?0:  ((Number(data.bsxj) / Number(data.studentCountSj)) * 100).toFixed(2) }}%；非国科大学籍联培生中，参测本科生{{ data.bklp }}人，占参测人数的{{ data.studentCountSj == 0?0:  ((Number(data.bklp) / Number(data.studentCountSj)) * 100).toFixed(2) }}%，硕士研究生有{{ data.sslp }}人，占参测人数的{{ data.studentCountSj==0?0: ((Number(data.sslp) / Number(data.studentCountSj)) * 100).toFixed(2) }}%，参测博士研究生有{{ data.bslp }}人，占参测人数的{{ data.studentCountSj==0?0:((Number(data.bslp) / Number(data.studentCountSj)) * 100).toFixed(2)
  }}%</p>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:10%;margin-top:20px;line-height:30px;">国科大学籍</p>
        <table>
            <thead>
                <tr>
                    <th>学历</th>
                    <th>人数（人）</th>
                    <th>百分比（%）</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>本科生</td>
                    <td>{{ data.bkxj }}</td>
                    <td>{{ data.studentCountSj == 0 ? 0: ((Number(data.bkxj)  / Number(data.studentCountSj)) * 100).toFixed(2) }}</td>
                </tr>
                <tr>
                    <td>硕士研究生</td>
                    <td>{{ data.ssxj }}</td>
                    <td>{{ data.studentCountSj==0? 0 : ((Number(data.ssxj) / Number(data.studentCountSj)) * 100).toFixed(2) }}</td>
                </tr>

                <tr>
                    <td>博士研究生</td>
                    <td>{{ data.bsxj }}</td>
                    <td>{{  data.studentCountSj ==0?0:  ((Number(data.bsxj) / Number(data.studentCountSj)) * 100).toFixed(2) }}</td>
                </tr>

            </tbody>
        </table>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:10%;margin-top:20px;line-height:30px;">联培生</p>
        <table>
            <thead>
                <tr>
                    <th>学历</th>
                    <th>人数（人）</th>
                    <th>百分比（%）</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>本科生</td>
                    <td>{{ data.bklp }}</td>
                    <td>{{ data.studentCountSj == 0?0:  ((Number(data.bklp) / Number(data.studentCountSj)) * 100).toFixed(2) }}</td>
                </tr>
                <tr>
                    <td>硕士研究生</td>
                    <td>{{ data.sslp }}</td>
                    <td>{{  data.studentCountSj==0?0: ((Number(data.sslp) / Number(data.studentCountSj)) * 100).toFixed(2) }}</td>
                </tr>

                <tr>
                    <td>博士研究生</td>
                    <td>{{ data.bslp }}</td>
                    <td>{{  data.studentCountSj==0?0:((Number(data.bslp) / Number(data.studentCountSj)) * 100).toFixed(2) }}</td>
                </tr>

            </tbody>
        </table>


        <div class="cvs">
            <p>二、量表情况统计</p>
        </div>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（一）总体情况统计</p>
        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:10%;margin-top:20px;line-height:30px;">贵单位参测学生中疑似出现心理问题的学生有{{ data.phProblemCountBX + data.phProblemCountLP }}人，总体满意度为基本不满意的学生有{{ data.bmyCountBX + data.bmyCountLP
  }}人</p>


        <table>
            <thead>
                <tr>
                    <th rowspan="2">类别</th>
                    <th colspan="2">本校生</th>
                    <th colspan="2">联培生</th>
                </tr>
                <tr>
                    <th>人数</th>
                    <th>百分比</th>
                    <th>人数</th>
                    <th>百分比</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>疑似出现心理问题的学生</td>
                    <td>{{ data.phProblemCountBX }}</td>
                    <td>{{ data.phProblemCountBXZb }}</td>
                    <td>{{ data.phProblemCountLP }}</td>
                    <td>{{ data.phProblemCountLPZb }}</td>
                </tr>
                <tr>
                    <td>满意度为基本不满意的学生</td>
                    <td>{{ data.bmyCountBX }}</td>
                    <td>{{ data.bmyCountBXZb }}</td>
                    <td>{{ data.bmyCountLP }}</td>
                    <td>{{ data.bmyCountLPZb }}</td>
                </tr>
            </tbody>
        </table>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（二）疑似出现心理问题的情况统计</p>


        <table>
            <thead>
                <tr>
                    <th>分类</th>
                    <th>总人数</th>
                    <th>男生</th>
                    <th>女生</th>
                    <th>本校生</th>
                    <th>联培生</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in data.phyProblemList" :key="index">
                    <td>{{ item.factorName }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.manCount }}</td>
                    <td>{{ item.womanCount }}</td>
                    <td>{{ item.bxCount }}</td>
                    <td>{{ item.lpCount }}</td>
                </tr>

            </tbody>
        </table>


        <table>
            <thead>
                <tr>
                    <th>分类</th>
                    <th>总人数</th>
                    <th>本科</th>
                    <th>研究生</th>
                    <th>博士生</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in data.phyProblemList" :key="index">
                    <td>{{ item.factorName }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.degreeUndergraduateCount }}</td>
                    <td>{{ item.degreeMasterCount }}</td>
                    <td>{{ item.degreeDoctorCount }}</td>

                    <!-- <td>{{ data.degree11Count }}</td> -->
                </tr>

            </tbody>
        </table>


        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">（三）生活满意度为基本不满意的情况统计</p>


        <table>
            <thead>
                <tr>
                    <th>分类</th>
                    <th>总人数</th>
                    <th>男生</th>
                    <th>女生</th>
                    <th>本校生</th>
                    <th>联培生</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in data.jbbmyList" :key="index">
                    <td>{{ item.factorName }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.manCount }}</td>
                    <td>{{ item.womanCount }}</td>
                    <td>{{ item.bxCount }}</td>
                    <td>{{ item.lpCount }}</td>
                </tr>

            </tbody>
        </table>

        <table>
            <thead>
                <tr>
                    <th style="width:80px">分类</th>
                    <th>总人数</th>
                    <th>本科</th>
                    <th>研究生</th>
                    <th>博士生</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in data.jbbmyList" :key="index">
                    <td>{{ item.factorName }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.degreeUndergraduateCount }}</td>
                    <td>{{ item.degreeMasterCount }}</td>
                    <td>{{ item.degreeDoctorCount }}</td>
                    </tr>

            </tbody>
        </table>


        <div class="cvs">
            <p>三、综合排查结果</p>
        </div>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">本次心理普查综合排查划分四个等级，各等级划分标准及处理建议和措施见下表：</p>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">注：心理测量只作为评估辅助工具，且为当事人主观填写，测量结果仅供参考，请结合实际情况进行综合评估与使用。</p>

        <table>
            <thead>
                <tr>
                    <th style="width: 60px;">风险等级</th>
                    <th>风险标准</th>
                    <th style="width: 60px;">处理等级</th>
                    <th>建议措施</th>
                </tr>
            </thead>
            <tbody>

                <tr>
                    <td>重度</td>
                    <td>SCL-90总分超过160分或阳性项目数超过43项，且抑郁或焦虑因子得分>2，且生活满意度量表T &lt; 25.40 </td>
                    <td>密切陪护</td>
                    <td>心理辅导员或心理咨询师须及时与当事人谈心谈话，引导当事人就医或接受专业人员帮助，初步评估并向心理中心报告。如情况属实（症状显著，确有自杀计划或自杀未遂，仅有自杀意念可以列为中等），须及时密切陪护（至少两名同性别人员24小时陪护），联系监护人及时到场，及时转介就医。</td>
                </tr>

                <tr>
                    <td>中度</td>
                    <td>SCL-90总分超过160分或阳性项目数超过43项，且抑郁或焦虑因子得分>2，且生活满意度量表T&lt; 32.80</td>
                    <td>重点关注</td>
                    <td>心理辅导员应及时与当事人谈心谈话，引导当事人接受专业人员帮助，初步评估（是否有自杀计划，是否有精神障碍诊断）并向心理中心报告。如情况属实（排除自杀计划和严重精神障碍诊断，有长期内心冲突或人际关系不良），建议当事人预约心理咨询或就医诊断治疗，须重点关注（每周谈心谈话一次），及时与监护人联系了解情况并告知现状。</td>
                </tr>

                <tr>
                    <td>轻度</td>
                    <td>SCL-90总分超过160分或阳性项目数超过43项，或任一因子分超过2分，或生活满意度量表T&lt; 32.80</td>
                    <td>适当关注</td>
                    <td>心理辅导员应适时与当事人谈心谈话，给予心理辅导，予以适当关注（每两周谈心谈话一次），找到监护人的联系方式，以便必要时可以及时沟通情况。</td>
                </tr>

                <tr>
                    <td>良好<br>（1级）</td>
                    <td>不满足以上任一条件</td>
                    <td>无</td>
                    <td>无特别建议，保持正常的交流沟通即可。</td>
                </tr>

            </tbody>
        </table>

        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">贵单位本次心理普查综合排查中，划分为重度风险{{ data.severe }}人，占比{{ data.severeZB }}%；划分为中度风险{{ data.moderate }}人，占比 {{ data.moderateZB }}%；划分为轻度风险{{ data.mild }}人，占比{{ data.mildZB }}%；划分为良好{{ data.good }}人，占比{{ data.goodZB }}%</p>

        <table>
            <thead>
                <tr>
                    <th>类型</th>
                    <th>人数（人）</th>
                    <th>百分比（%）</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>重度风险</td>
                    <td>{{ data.severe }}</td>
                    <td>{{ data.severeZB }}</td>
                </tr>
                <tr>
                    <td>中度风险</td>
                    <td>{{ data.moderate }}</td>
                    <td>{{ data.moderateZB }}</td>
                </tr>
                <tr>
                    <td>轻度风险</td>
                    <td>{{ data.mild }}</td>
                    <td>{{ data.mildZB }}</td>
                </tr>
                <tr>
                    <td>良好</td>
                    <td>{{ data.good }}</td>
                    <td>{{ data.goodZB }}</td>
                </tr>
            </tbody>
        </table>



        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">在本次综合排查中，重度风险中男生{{ data.severeSex1 }}人，女生{{ data.severeSex0 }}人；中度风险中男生{{ data.moderateSex1 }}人，女生{{data.moderateSex0}}人；轻度风险中男生{{ data.mildSex1 }}人，女生{{ data.mildSex0 }}人，分布如下图所示。</p>



        <table>
            <thead>
                <tr>
                    <th>类型</th>
                    <th>男生</th>
                    <th>女生</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>重度风险</td>
                    <td>{{ data.severeSex1 }}</td>
                    <td>{{ data.severeSex0 }}</td>
                </tr>
                <tr>
                    <td>中度风险</td>
                    <td>{{ data.moderateSex1 }}</td>
                    <td>{{ data.moderateSex0 }}</td>
                </tr>
                <tr>
                    <td>轻度风险</td>
                    <td>{{ data.mildSex1 }}</td>
                    <td>{{ data.mildSex0 }}</td>
                </tr>
            </tbody>
        </table>



        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">在本次综合排查中，本校生：重度风险中本科生{{ data.severeDegree0 }}人，硕士研究生{{
      data.severeDegree1 }}人，博士研究生{{ data.severeDegree2 }}人；中度风险中本科生{{ data.moderateDegree0 }}人，硕士研究生{{
    data.moderateDegree1 }}人，博士研究生{{ data.moderateDegree2 }}人；轻度风险中本科生{{ data.mildDegree0 }}人，硕士研究生{{ data.mildDegree1
  }}人，博士研究生{{ data.mildDegree2 }}人。联培生：重度风险中本科生{{ data.severeDegreeLP0 }}人，硕士研究生{{ data.severeDegreeLP1 }}人，博士研究生{{
  data.severeDegreeLP2 }}人；中度风险中本科生{{ data.moderateDegreeLP0 }}人，硕士研究生{{ data.moderateDegreeLP1 }}人，博士研究生{{
    data.moderateDegreeLP2 }}人；轻度风险中本科生{{ data.mildDegreeLP0 }}人，硕士研究生{{ data.mildDegreeLP1 }}人，博士研究生{{
    data.mildDegreeLP2 }}人。分布如下图所示。</p>
        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:10%;margin-top:20px;line-height:30px;">本校生</p>
        <table>
            <thead>
                <tr>
                    <th>类型</th>
                    <th>本科生</th>
                    <th>硕士研究生</th>
                    <th>博士研究生</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>重度风险</td>
                    <td>{{ data.severeDegree0 }}</td>
                    <td>{{ data.severeDegree1 }}</td>
                    <td>{{ data.severeDegree2 }}</td>
                </tr>
                <tr>
                    <td>中度风险</td>
                    <td>{{ data.moderateDegree0 }}</td>
                    <td>{{ data.moderateDegree1 }}</td>
                    <td>{{ data.moderateDegree2 }}</td>
                </tr>
                <tr>
                    <td>轻度风险</td>
                    <td>{{ data.mildDegree0 }}</td>
                    <td>{{ data.mildDegree1 }}</td>
                    <td>{{ data.mildDegree2 }}</td>
                </tr>
            </tbody>
        </table>
        <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:10%;margin-top:20px;line-height:30px;">联培生</p>
        <table>
            <thead>
                <tr>
                    <th>类型</th>
                    <th>本科生</th>
                    <th>硕士研究生</th>
                    <th>博士研究生</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>重度风险</td>
                    <td>{{ data.severeDegreeLP0 }}</td>
                    <td>{{ data.severeDegreeLP1 }}</td>
                    <td>{{ data.severeDegreeLP2 }}</td>
                </tr>
                <tr>
                    <td>中度风险</td>
                    <td>{{ data.moderateDegreeLP0 }}</td>
                    <td>{{ data.moderateDegreeLP1 }}</td>
                    <td>{{ data.moderateDegreeLP2 }}</td>
                </tr>
                <tr>
                    <td>轻度风险</td>
                    <td>{{ data.mildDegreeLP0 }}</td>
                    <td>{{ data.mildDegreeLP1 }}</td>
                    <td>{{ data.mildDegreeLP2 }}</td>
                </tr>
            </tbody>
        </table>



    <div class="cvs">
        <p>四、综合排查名单</p>
    </div>


    <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">1、重度风险人员：风险人数：{{ data.severe }}人，预警比例：{{ ((Number(data.severe) / Number(data.studentCountSjCount))*100).toFixed(2)  }}%。</p>

    <table>
        <thead>
            <tr>
                <th>序号</th>
                <th>学号</th>
                <th>性别</th>
                <th>培养单位</th>
                <th>学历</th>
                <th>SCL-90总分</th>
                <th>生活满意度总分均分</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, i) in data.severeTableList" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ item.userID }}</td>
                <td>{{ item.sex }}</td>
                <td>{{ item.deptName }}</td>
                <td>{{ item.degree }}</td>
                <td>{{ item.sclScore }}</td>
                <td>{{ item.lsoftScore }}</td>
            </tr>
        </tbody>
    </table>

    <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">2、中度风险人员：风险人数：{{ data.moderate }}人，预警比例：{{ ((Number(data.moderate) / Number(data.studentCountSjCount))*100).toFixed(2) }}%。</p>

    <table>
        <thead>
            <tr>
                <th>序号</th>
                <th>学号</th>
                <th>性别</th>
                <th>培养单位</th>
                <th>学历</th>
                <th>SCL-90总分</th>
                <th>生活满意度总分均分</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, i) in data.moderateTableList" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ item.userID }}</td>
                <td>{{ item.sex }}</td>
                <td>{{ item.deptName }}</td>
                <td>{{ item.degree }}</td>
                <td>{{ item.sclScore }}</td>
                <td>{{ item.lsoftScore }}</td>
            </tr>
        </tbody>
    </table>


    <p style="color: rgba(18, 18, 18, 1);font-size: 16px;width: 90%;margin-left:5%;margin-top:20px;line-height:30px;">3、轻度风险人员：风险人数：{{ data.mild }}人，预警比例 {{ ((Number(data.mild) / Number(data.studentCountSjCount))*100).toFixed(2) }}%。</p>

    <table>
        <thead>
            <tr>
                <th>序号</th>
                <th>学号</th>
                <th>性别</th>
                <th>培养单位</th>
                <th>学历</th>
                <th>SCL-90总分</th>
                <th>生活满意度总分均分</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, i) in data.mildTableList" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ item.userID }}</td>
                <td>{{ item.sex }}</td>
                <td>{{ item.deptName }}</td>
                <td>{{ item.degree }}</td>
                <td>{{ item.sclScore }}</td>
                <td>{{ item.lsoftScore }}</td>
            </tr>
        </tbody>
    </table>

    </div>

    <el-button type="primary" style="position: fixed;top:200px;right:20px" @click="dcfub()">导出</el-button>

   


  </div>
</template>
<script>
export default {
  data() {
    return {
        loading:true,

        data:'',
    }
  },
  methods: {
    dcfub(){
        this.$Http_Post('ScaleIssue/GetMentalHealthWord', { ReportType: this.ReportType[0], PublishID: this.PaperResultID[0], DeptID : this.DeptID[0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.open(res.Data, '_blank');
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    tba(){
        this.$Http_Post('ScaleIssue/GetMentalHealth', { ReportType: this.ReportType[0], PublishID: this.PaperResultID[0], DeptID: [this.$route.query.DeptID][0], NianJI: [this.$route.query.NianJI][0] }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
                this.loading = false;
                this.data = res.Data;
            }else{
                this.$router.push({path: "/Client/PuceReport"});
                this.Global.request_failure(res.Message);
            }
        })
    },
  },
  mounted() {
    this.PaperResultID = [this.$route.query.PaperResultID];
    this.ReportType = [this.$route.query.ReportType];
    this.DeptID = [this.$route.query.DeptID];
    this.NianJI = [this.$route.query.NianJI];
    this.$nextTick(()=>{
        this.tba()
    });
    
  },
}
</script>
<style>
.Mental_health_report{width: 100%;height: 100%;background: #fff;}
.Mental_health_report .nav{width: 1000px;margin: auto;height: 100%;background-image: url('../../assets/12.png');overflow: auto;background-size:1000px}
.Mental_health_report .nav h2{font-size: 28px;color: rgba(0, 103, 202, 1);text-align: center;padding-top: 30px;}
.Mental_health_report .nav .cvs{background: linear-gradient(90deg, rgba(53, 142, 253, 0.1) 0%, rgba(62, 61, 210, 0.1) 100%);height: 45px;width: 220px;line-height: 45px;border-radius: 25px;color: rgba(0, 103, 202, 1);margin-top: 30px;text-indent: 40px;margin-left: -20px;font-weight: 700;font-size: 18px;
}



.Mental_health_report table {border-collapse: collapse; width: 80%;margin: 20px auto;font-family: Arial, sans-serif;}
.Mental_health_report  th,td {border: 1px solid #ddd;padding: 12px;text-align: left;text-align: center;}
 th {background-color: #f2f2f2;color: #333;}
/* tr:nth-child(even) {background-color: #f9f9f9;} */
.Mental_health_report tr:hover {background-color: #e5f6ff;}
</style>
